import React, { useEffect, useState } from "react";
import "./Home.css";
import LoginForm from "../Login/LoginForm";
import axios from "axios";
import url from "../../utils";
import Loader from "../Loader/Loader";

const Home = ({ consumerData, rationId, logoutHandler }) => {

    const [showPopup, setShowPopup] = useState(false);
    const [consumerId, setConsumerId] = useState(null);
    const [NOCFlag, setNOCFlag] = useState();
    const [subsidyOfOut, setSubsidyOfOut] = useState();
    const [rationFlag, setRationFlag] = useState();
    const [validateOtp, setValidateOtp] = useState(0);
    const [updateUserLoder, setUpdateUserLoder] = useState(false)
    const [rationSubsidyCount, setRationSubsidyCount] = useState(0)
    const [getConsumerDetailsLoder, setGetConsumerDetailsLoder] = useState(false)
    const [data, setData] = useState(consumerData);

    // const [data, setData]=useState([
    //     {
    //         "address": "SHIMLA,SHIMLA,. KATHIAN 171006",
    //         "stopSubsidyFlag": false,
    //         "consumerId": "100001138443",
    //         "rationCardNumber": "HP2025073083379",
    //         "NOCFlag": false,
    //         "subDivision": "DHALLI SUB-DIVISION",
    //         "phoneNumer": "9805979816",
    //         "rationFlag": false,
    //         "consumerName": "BHAGAT RAM ."
    //     }])


    // handle session 
    const SESSION_DURATION = 15 * 60 * 1000;

    useEffect(() => {

        setRationSubsidyCount(
            data.filter(consumer => consumer.rationFlag).length
        );

        //   validate the session after one minutes
        const interval = setInterval(() => {
            const session = JSON.parse(sessionStorage.getItem("userSession"));

            if (!session) {
                logoutHandler();
                return;
            }

            if (Date.now() - session.startTime > SESSION_DURATION) {
                alert("Session expired. Please login again.");
                sessionStorage.clear();
                logoutHandler();
            }
        }, 60 * 1000); // check every 1 minute

        return () => clearInterval(interval);


    }, [data, logoutHandler])

    const openVerificationPopup = (id, nocFlag, sbdyOfOut, rtnFlag) => {
        setConsumerId(id);
        setNOCFlag(nocFlag);
        setSubsidyOfOut(sbdyOfOut);
        setValidateOtp(0);
        setRationFlag(rtnFlag);
        setShowPopup(true);
    };

    const updatedetailsHandler = async () => {
        try {
            setUpdateUserLoder(true);
            // console.log(consumerId, NOCFlag, subsidyOfOut, rationFlag)
            const { data } = await axios.post(`${url}RationCardSubsidy/UpdateDetails`,
                {
                    consumerId: consumerId,
                    nocFlag: NOCFlag,
                    subsidyOfOut: subsidyOfOut,
                    rationFlag: rationFlag
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )

            // console.log("update details:", data);
            if (data.success) {
                alert(data.message);
                setShowPopup(false)
                handleGetConsumerDetails();
            } else {
                alert(data.message);
            }

        } catch (error) {

            if (error.response) {
                // ✅ Backend error
                // console.error("API Error:", error.response.data);
                // console.error("Status:", error.response.status);

                alert(
                    error.response.data.message ||
                    "Failed to update consumer details"
                );

            } else if (error.request) {
                // ✅ Request but no response
                // console.error("No response:", error.request);
                alert("No response from server");

            } else {
                // ✅ Other error
                // console.error("Error:", error.message);
                alert("Something went wrong");
            }
        } finally {
            setUpdateUserLoder(false);
        }
    }


    const handleGetConsumerDetails = async () => {
        try {
            setGetConsumerDetailsLoder(true);
            const { data } = await
                axios.get(`${url}RationCardSubsidy/GetConsumerDetails?consumerId=${consumerId}&rationCard=${rationId}`,
                )
            // console.log("get consumer details", data)
            setData(data.data)
            // setValidateDetails(true)
        } catch (err) {
            alert(err.response.data.message)
        } finally {
            // setLoginLoader(false)
            setGetConsumerDetailsLoder(false);
        }
    }


    return (
        <div className="table-container">
            <div className="headers">
                <h1>Ration Card Subsidy</h1>
                <button style={{ backgroundColor: "red" }} onClick={logoutHandler}>
                    Logout
                </button>
            </div>
            
            <div className="table-title">
                <h3>Ration Card: {rationId}</h3>
            </div>
            {getConsumerDetailsLoder ? <Loader /> :
                <table className="consumer-table">
                    <thead>
                        <tr>
                            <th>Consumer ID</th>
                            <th>Name</th>
                            <th>Sub Division</th>
                            <th>Address</th>
                            <th>Phone</th>
                            <th>Without NOC</th>
                            <th>Subsidy Opt out</th>
                            <th>Change Consumer ID for <br /> Ration Card based subsidy</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((consumer) => (
                            <tr key={consumer.consumerId}>
                                <td>{consumer.consumerId}</td>
                                <td>{consumer.consumerName}</td>
                                <td>{consumer.subDivision}</td>
                                <td>{consumer.address}</td>
                                <td>{"XXXXXXX" + consumer.phoneNumer.substring(7, 10)}</td>

                                {/* Disabled flags */}
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={consumer.NOCFlag}
                                        disabled
                                    />
                                </td>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={consumer.stopSubsidyFlag}
                                        disabled
                                    />
                                </td>

                                {/* Editable subsidy */}
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={consumer.rationFlag}
                                        //   disabled={consumer.stop_flag}
                                        onChange={(e) =>
                                            openVerificationPopup(
                                                consumer.consumerId,
                                                consumer.NOCFlag,
                                                consumer.stopSubsidyFlag,
                                                e.target.checked
                                            )
                                        }
                                        disabled={consumer.stopSubsidyFlag || consumer.NOCFlag || (rationSubsidyCount >= 2 && !consumer.rationFlag)}
                                        title={
                                            consumer.stopSubsidyFlag
                                                ? "Subsidy opt-out is enabled"
                                                : consumer.NOCFlag
                                                    ? "Without NOC is enabled"
                                                    : rationSubsidyCount >= 2 && !consumer.rationFlag
                                                        ? "Maximum 2 consumers allowed for ration subsidy"
                                                        : "Click to change ration subsidy"
                                        }

                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            }

            {/* this is a popup to verify the the otp and update the changes */}
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup-card">
                        <h3>Verification of Changes</h3>

                        <div className="inputBox">
                            <LoginForm
                                setValidateOtp={setValidateOtp}
                                validateOtp={validateOtp}
                                consumerId={consumerId}
                                setConsumerID={consumerId}
                                updateDetailsOtp={true}
                            />
                            {
                                updateUserLoder ? <Loader /> :
                                    <button
                                        disabled={updateUserLoder || validateOtp < 2}
                                        className={`${validateOtp < 2 ? "disabled" : ""}`}
                                        type="button"
                                        onClick={updatedetailsHandler}
                                    >
                                        Update Consumer
                                    </button>
                            }

                        </div>
                        <button onClick={() => setShowPopup(false)}>Cancel</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Home;
